import {useEffect} from "react";
import {storage} from "./localstorage";

export const QRCode = () => {
    useEffect(() => {
        storage("qrcode", "qrcode");
        document.location = "/"
    }, [])
    return false;
}
